import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import type {
  CreateCrmProductRequestDto,
  CreateCrmProductResponseDto
} from "../../dtos/crm-product-dto";
import { ProductService } from "../../services/product-service";

type UsePutUpdateCrmProductMutationParams = {
  options?: UseMutationOptions<
    CreateCrmProductResponseDto,
    unknown,
    CreateCrmProductRequestDto & { productId: string }
  >;
};

export const usePutUpdateCrmProductMutation = ({
  options
}: UsePutUpdateCrmProductMutationParams = {}) => {
  return useMutation({
    mutationFn: async (payload) => {
      return await ProductService.updateCrmProduct({ payload });
    },
    ...options
  });
};
